import { Store } from 'vuex';
import { PaymentProviderBankDetails, VerificationStatuses } from '@/interfaces/bank-account';
import { OnboardingDetails } from '@/interfaces/onboarding';
import { PaymentOptionsStoreState, PaymentProviderCardDetails } from '@/interfaces/payment-options';
import { AchProviders } from '@/constants/payments';

export function isLoading(state: PaymentOptionsStoreState): boolean {
  return state.loading;
}

export function getOnboardingDetails(state: PaymentOptionsStoreState): OnboardingDetails | null {
  return state.onboardingDetails;
}

export function getBankAccount(state: PaymentOptionsStoreState): PaymentProviderBankDetails | null {
  const entries = Object.entries(state.bankAccounts);
  if (!entries.length) return null;

  return {
    id: entries[0][0],
    ...entries[0][1]
  };
}

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export function bankAccountIsVerified(_: PaymentOptionsStoreState, getters: any): boolean {
  const statusesTreatedAsVerified: string[] = [
    VerificationStatuses.VERIFIED,
    VerificationStatuses.CRB_ONBOARDED
  ];
  return statusesTreatedAsVerified
    .includes((getters.getBankAccount as PaymentProviderBankDetails | null)?.bank_status || '');
}

export function getCard(state: PaymentOptionsStoreState): PaymentProviderCardDetails | null {
  const entries = Object.entries(state.cards);
  if (!entries.length) return null;

  return {
    id: entries[0][0],
    ...entries[0][1]
  };
}

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export function hasVerifiedPaymentMethods(_: PaymentOptionsStoreState, getters: any): boolean {
  return getters.bankAccountIsVerified || !!getters.getCard;
}

export function achProvider(
  state: PaymentOptionsStoreState,
  getters: unknown,
  rootState: Store<unknown>,
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  rootGetters: any,
): AchProviders | null {
  return rootGetters['User/achProvider'];
}
